import React, { ReactNode, useState } from 'react';
import axios from 'axios';
import '../Pincodefinder/Style.css';
import '../Pincodefinder/Track.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Logo from '../Logo/logo.png';

interface TempodEntry {
  EntryDate: string;
  EntryTime: string;
  Details: string;
  Remark: string;
}

interface TrackingRecord {
  CNoteNo: string;
  InvoiceNo: string;
  ExptDateDelivery: string;
  VendorAwbNo: string;
  bookdate: string;
  ConsigneeName: string;
  Status: string;
  qty: string;
  R_City: string;
  Origin: string;
  Mode: string;
  recvName: string;
  statusDt: string;
  delvTime: string;
  remark: ReactNode;
  tempodData: TempodEntry[];
  ImageLink: string;
}

const Tracking: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState('');
  const [currentStep, setCurrentStep] = useState(1);



  const statusToStep: { [key: string]: number } = {
    'Shipped': 1,
    'In Transit': 2,
    'Delivered': 3,
  };

  const handleButtonClick = () => {
    setShowImage(!showImage); // Toggle the image visibility
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.slice(0, 200);
    setSearchValue(inputValue);
    setError('');
    setTrackingData([]);
  };

  const fetchData = async () => {
    try {
      if (searchValue.trim() === '') {
        setError('Please enter one or more tracking numbers separated by commas.');
        return;
      }

      const CNoteNo = searchValue.split(',').map(awb => awb.trim());
      const res = await axios.post('https://airkingexpress.net/AirkingexpressAPI/getTrackingData', { CNoteNo });
      const data = res.data;

      console.log(data, "Response from API");

      if (data.status === 1 && data.Data) {
        const updatedData = data.Data.map((item: TrackingRecord) => {
          const imageId = item.CNoteNo; // Assuming CNoteNo is used for image URL
          item.ImageLink = `https://airkingexpress.net/portalapi/PODIMAGE/${imageId}.jpg`; // Create the image URL
          return item; // Return the updated item
        });

        setTrackingData(updatedData); // Update state with the modified data including ImageLink
        setError('');

        // Update the currentStep based on the status of the first record
        if (updatedData.length > 0) {
          const status = updatedData[0].Status; // Assuming status is relevant for the first record
          setCurrentStep(statusToStep[status] || 1); // Default to step 1 if status is unknown
        }
      } else {
        setError('Docket Not Found');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('Failed to fetch data. Please check your internet connection.');
    }
  };

  return (
    <>


      <div className="container-fluid">
        <div className="row">
          <label htmlFor="" className='background'>
          <b> Welcome to Air King Express Cargo</b>  | 

             <a className='back' href="https://airkingexpress.net/">
            <b>Back To Home</b> </a>
          </label>

          <div className="col-lg-6 logo-container">
            <img
              src={Logo}
              alt="Company Logo"
              className="logo-image"
            />
          </div>
          <div className="col-lg-6 ">
           

            <label className="contact" htmlFor=""> 
             <b>Email: airkingexpress@gmail.com  Contact No:  9322033242/9323236687</b><br>
            </br>

                                   </label>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <h5 className='BLuedarttracking'><b> Air king Express Cargo - Tracking Details</b></h5>

            {trackingData.length > 0 ? (
              trackingData.map((record, index) => (
                <div key={index} className="shadow p-4 mb-4">
                  <table className="table table-bordered table-sm mb-4">
                    <thead>
                      <tr>
                        <th>Waybill No</th>
                        <th>Invoice No</th>
                        <th>Expt Date of Delivery</th>
                        <th>Status</th>
                        <th>Date of Delivery</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{record.CNoteNo}</td>
                        <td>{record.InvoiceNo}</td>
                        <td>{record.ExptDateDelivery}</td>
                        <td>{record.Status}</td>
                        <td>{record.statusDt}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))
            ) : (
              <div>No tracking data available.</div>
            )}

            <div className="steps-container">
              {[1, 2, 3].map(number => (
                <span key={number} className="step-container">
                  {number > 1 && <div className="line"></div>}
                  <span className={`step-circle ${number <= currentStep ? 'active' : ''}`}>
                    {number}
                  </span>
                  <span className="step-label">{number === 1 ? 'Shipped' : number === 2 ? 'In Transit' : 'Delivered'}</span>
                </span>
              ))}
              <div className="progress-bar-container">
                <span
                  className="progress-indicator"
                  style={{ width: `${((currentStep - 1) / 2) * 100}%` }} // Adjusted to 2 for 3 steps
                ></span>
              </div>
            </div>
          
          

        </div>

        <div className="col-lg-4">
          <div className="shadow p-4">
            <h1><b className='Track'>TRACK</b></h1>
            <div className="centered-input-container">
              <input
                type="text"
                className="form-control mb-3 centered-input"
                placeholder="Tracking Number(s)"
                value={searchValue}
                onChange={handleInputChange}
              />
            </div>
            <button onClick={fetchData} className="Tracking">TRACK</button>
            {error && <div className="text-danger mt-2">{error}</div>}
            <p className="mt-2">To track multiple waybills, enter tracking numbers separated by commas.</p>
          </div>
        </div>
      </div>
    </div >

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" className="tab-center">
              <Tab eventKey="details" title="Shipment Details">
                {trackingData.length > 0 ? (
                  trackingData.map((record, index) => (
                    <div key={index} className="shadow p-4 mb-3">
                      <div className="shipment-details">
                        <div className="detail-row">
                          <span className="detail-label">Waybill No:</span>
                          <span className="detail-value">{record.CNoteNo}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Forwarding No:</span>
                          <span className="detail-value">{record.VendorAwbNo}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Pickup Date:</span>
                          <span className="detail-value">{record.bookdate}</span>
                        </div>
                        {/* <div className="detail-row">
                          <span className="detail-label">Mode:</span>
                          <span className="detail-value">{record.Mode}</span>
                        </div> */}
                        <div className="detail-row">
                          <span className="detail-label">From:</span>
                          <span className="detail-value">{record.Origin}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">To:</span>
                          <span className="detail-value">{record.R_City}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Status:</span>
                          <span className="detail-value">{record.Status}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Date of Delivery:</span>
                          <span className="detail-value">{record.statusDt}</span>
                        </div>
                        <div>

                          <button className="btn btn-success" onClick={handleButtonClick}>
                            {showImage ? 'Hide Image' : 'Pod Image'}
                          </button>
                          {showImage && (
                            <div className="image-container mt-2">

                              {trackingData.length > 0 && (
                                <img src={trackingData[0].ImageLink} alt="Tracking" className="img-fluid" />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>No shipment details available.</div>
                )}
              </Tab>

              <Tab eventKey="status" title="Status and Scans" className="tab-center">
                {trackingData.length > 0 ? (
                  trackingData.map((record, index) => (
                    <div key={index}>
                      <p><b className='ShipmentDetails'>Status and Scans</b></p>
                      <div className="scrollable-table">
                        <table className="table table-bordered table-sm">
                          <thead className='background'>
                            <tr>
                              <th>Location</th>
                              <th>Status</th>
                              <th>Date</th>
                              <th>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {record.tempodData && record.tempodData.length > 0 ? (
                              record.tempodData.map((entry, idx) => (
                                <tr key={idx}>
                                  <td>{entry.Details}</td>
                                  <td>{entry.Remark}</td>
                                  <td>{entry.EntryDate}</td>
                                  <td>{entry.EntryTime}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4}>No scans available.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>No status and scans available.</div>
                )}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tracking;
